import { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { setNoticePermissions } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";

function NoticePermissionsSet(props) {
  const { intl } = props;
  const { authData } = props;
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {},
    onSubmit: (values, { setValues, setStatus, setSubmitting }) => {
      const permissionData = {
        schoolId: authData.schoolId,
        userId: authData.userId,
        personId: authData.personId,
        userType: authData.userType,
        isMailNotificationAllowed: values.isMailNotificationAllowed,
        isSMSNotificationAllowed: values.isSMSNotificationAllowed,
        isWhatsAppNotificationAllowed: values.isWhatsAppNotificationAllowed
      };
      setSubmitting(true);
      setLoading(true);      
      setNoticePermissions(permissionData)
      .then(({ data: { type, message } }) => {
        setValues(type);
        setStatus(message);
      })
      .catch(() => {
        setValues("danger");
        setStatus(
          "İşlem Sırasında Bir Hata Oluştu. Lütfen Sistem Yöneticiniz İle İrtibata Geçiniz!"
          // intl.formatMessage({
          //   id: "AUTH.VALIDATION.INVALID_LOGIN",
          // })
        );
      })
      .finally(() => {
        setLoading(false);
        setSubmitting(false);
      });
    }
  });

  return (
    <div className="login-form login-signin" style={{ display: "block" }}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">
          {authData.schoolName}
        </h3>
        <p className="text-muted font-weight-bold">
          Enter your details to create your account
        </p>
      </div>

      <form
        id="kt_login_signin_form"
        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
        onSubmit={formik.handleSubmit}
      >
        {/* begin: Alert */}
        {formik.status && (
          <div className={`mb-10 alert alert-custom alert-light-${formik.values} alert-dismissible`}>
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        )}
        {/* end: Alert */}

        {/* begin: Hülagü */}
        <div className="form-group row">
          <label className="mt-1 mr-10">Gönderim Türü</label>

          <label className="checkbox mr-5">
            <input
              type="checkbox"
              {...formik.getFieldProps("isMailNotificationAllowed")}
            />
            <span />
          </label>
          <label className="mt-1 mr-10">Mail</label>

          <label className="checkbox mr-5">
            <input
              type="checkbox"
              {...formik.getFieldProps("isSMSNotificationAllowed")}
            />
            <span />
          </label>
          <label className="mt-1 mr-10">SMS</label>

          <label className="checkbox mr-5">
            <input
              type="checkbox"
              {...formik.getFieldProps("isWhatsAppNotificationAllowed")}
            />
            <span />
          </label>
          <label className="mt-1">WhatsApp</label>
        </div>
        {/* end: Hülagü */}

        <div className="form-group d-flex flex-wrap flex-center">
          <button
            type="submit"
            disabled={
              formik.isSubmitting ||
              !formik.isValid
            }
            className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
          >
            {!loading && <span>Kaydet</span>}
            {
              loading &&
              <>
                <span>Kaydediliyor</span>
                <span className="ml-3 spinner spinner-white"></span>
              </>
            }
          </button>
        </div>
      </form>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(NoticePermissionsSet));